import type { IModalDocumentsTipsProps } from './modal-documents-tips.types'
import { ModalDocumentsTipsView } from './modal-documents-tips.view'

export const ModalDocumentsTips = (props: IModalDocumentsTipsProps) => {
  return <ModalDocumentsTipsView {...props} />
}
